import {gsap} from "gsap";
import {SplitText as SplitTextPlugin} from "gsap/SplitText";
import {ScrollTrigger} from "gsap/ScrollTrigger";

export class SplitChar {
  constructor() {
    this._elements = document.querySelectorAll("[animation-split-char]");
    this.init();
  }

  init() {
    gsap.registerPlugin(SplitTextPlugin);
    gsap.registerPlugin(ScrollTrigger);
    if (!this._elements) return;

    if (window.innerWidth > 768) {
      this._elements.forEach((el) => {
        el.style.opacity = "1";


        const index = Array.from(this._elements).indexOf(el);
        const split = SplitTextPlugin.create(el, {
          type: "chars",
          mask: "chars",
          autoSplit: true,
        });

        gsap.from(split.chars, {
          duration: 1,
          y: 100,
          autoAlpha: 0,
          opacity: 0,
          transform: 'rotate(5deg) translateX(10px)',
          stagger: 0.05,
          scrollTrigger: {
            trigger: el,
            start: "top bottom",
            end: "bottom 65%",
            scrub: 1,
          },
        });
      });
    }
  }
}
